module.exports = __webpack_public_path__ + "preview.svg?8e46bdf53cdede3236bc7017c640a5dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preview.svg
// module id = 504
// module chunks = 0